<template>
  <div v-if="user.isKind('admin')" class="p-4 border border-solid border-error">
    <div class="text-xs text-error font-bold mb-3">{{ t("admin.adminOnly") }}</div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import { useUserStore } from "@/store/user";

const { t } = useI18n();
const user = useUserStore();
</script>
